"use strict";
// a TypeScript enum is compiled to a const and a type
// https://stackoverflow.com/a/54562617
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncidentTypeNames = exports.Severity = exports.AlertIncidentType = exports.RuleToAlertIncidentMap = exports.IncidentType = exports.AlertTriggerType = exports.EntityRules = exports.DeviceRules = exports.NetworkRules = exports.SystemRules = exports.RuleTypes = void 0;
/**
 * @deprecated use {@link AlertIncidentType} instead
 */
var Types;
(function (Types) {
    Types["NETWORK_AWOL"] = "NETWORK_AWOL";
    Types["GATEWAY_AWOL"] = "GATEWAY_AWOL";
    Types["DEVICE_AWOL"] = "DEVICE_AWOL";
    Types["SYSTEM_ISSUE"] = "SYSTEM_ISSUE";
    Types["BUSINESS_RULE_VIOLATION"] = "BUSINESS_RULE_VIOLATION";
})(Types || (Types = {}));
/**
 * Top-level category for alert / incident rules
 * For use in the UI selection of actual rules, and categorisation / distinction where necessary
 */
var RuleTypes;
(function (RuleTypes) {
    RuleTypes["SYSTEM"] = "SYSTEM";
    RuleTypes["NETWORK"] = "NETWORK";
    RuleTypes["DEVICE"] = "DEVICE";
    RuleTypes["ENTITY"] = "ENTITY";
})(RuleTypes || (exports.RuleTypes = RuleTypes = {}));
/**
 * Sub-category for {@link RuleTypes.SYSTEM}
 */
var SystemRules;
(function (SystemRules) {
    SystemRules["SYSTEM_ISSUE"] = "SYSTEM_ISSUE";
})(SystemRules || (exports.SystemRules = SystemRules = {}));
/**
 * Sub-category for {@link RuleTypes.NETWORK}
 */
var NetworkRules;
(function (NetworkRules) {
    NetworkRules["NETWORK_AWOL"] = "NETWORK_AWOL";
    NetworkRules["GATEWAY_AWOL"] = "GATEWAY_AWOL";
    NetworkRules["GATEWAY_CONGESTED"] = "GATEWAY_CONGESTED";
})(NetworkRules || (exports.NetworkRules = NetworkRules = {}));
/**
 * Sub-category for {@link RuleTypes.DEVICE}
 */
var DeviceRules;
(function (DeviceRules) {
    DeviceRules["DEVICE_AWOL"] = "DEVICE_AWOL";
    DeviceRules["POOR_SIGNAL"] = "POOR_SIGNAL";
    DeviceRules["GATEWAY_CHANGED"] = "GATEWAY_CHANGED";
    DeviceRules["NETWORK_CHANGED"] = "NETWORK_CHANGED";
})(DeviceRules || (exports.DeviceRules = DeviceRules = {}));
/**
 * Sub-category for {@link RuleTypes.ENTITY}
 */
var EntityRules;
(function (EntityRules) {
    EntityRules["BUSINESS_RULE_VIOLATION"] = "BUSINESS_RULE_VIOLATION";
    EntityRules["SYSTEM_RULE_VIOLATION"] = "SYSTEM_RULE_VIOLATION";
})(EntityRules || (exports.EntityRules = EntityRules = {}));
/** @deprecated use {@link AlertIncidentType} instead */
exports.AlertTriggerType = Types;
/** @deprecated use {@link AlertIncidentType} instead */
exports.IncidentType = Types;
exports.RuleToAlertIncidentMap = {
    [RuleTypes.SYSTEM]: SystemRules,
    [RuleTypes.NETWORK]: NetworkRules,
    [RuleTypes.DEVICE]: DeviceRules,
    [RuleTypes.ENTITY]: EntityRules,
};
exports.AlertIncidentType = { ...SystemRules, ...NetworkRules, ...DeviceRules, ...EntityRules };
var Severity;
(function (Severity) {
    Severity["CATASTROPHIC"] = "CATASTROPHIC";
    Severity["EXTREME"] = "EXTREME";
    Severity["HIGH"] = "HIGH";
    Severity["MEDIUM"] = "MEDIUM";
    Severity["LOW"] = "LOW";
    Severity["NONE"] = "NONE";
})(Severity || (exports.Severity = Severity = {}));
exports.IncidentTypeNames = {
    SYSTEM_ISSUE: 'System Issue',
    NETWORK_AWOL: 'Network AWOL',
    GATEWAY_AWOL: 'Gateway AWOL',
    GATEWAY_CONGESTED: 'Gateway Congested',
    DEVICE_AWOL: 'Device AWOL',
    BUSINESS_RULE_VIOLATION: 'Business Rule',
    SYSTEM_RULE_VIOLATION: 'System Rule',
    GATEWAY_CHANGED: 'Gateway Changed',
    NETWORK_CHANGED: 'Network Changed',
    POOR_SIGNAL: 'Poor Signal',
};
